"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Growth() {
  const rule = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const heading = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.15
  });
  const paragraph = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.15
  });
  const cta = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="20288" id="ready-for-growth" className="bg-background text-foreground py-24 md:py-44">
      <div className="mx-auto w-full max-w-[760px] px-6 md:px-8 text-center">
        <div ref={rule.ref} className="mx-auto h-px bg-border transition-all ease-out" style={{
        width: rule.isVisible ? "96px" : "0px",
        transitionDuration: "700ms"
      }} aria-hidden="true" />

        <h2 ref={heading.ref} className="font-default font-semibold text-foreground mt-10 md:mt-12" style={{
        fontSize: "clamp(2rem, 1.3rem + 3vw, 3.5rem)",
        lineHeight: 1.08,
        letterSpacing: "-0.014em",
        opacity: heading.isVisible ? 1 : 0,
        transform: heading.isVisible ? "translateY(0)" : "translateY(16px)",
        transition: "opacity 600ms cubic-bezier(0.2,0,0,1) 80ms, transform 600ms cubic-bezier(0.2,0,0,1) 80ms"
      }}>
          {"Initiate a "}
          <em className="italic font-normal text-primary">technical</em>
          {" assessment"}
        </h2>

        <p ref={paragraph.ref} className="font-default mx-auto mt-8 text-foreground/75" style={{
        maxWidth: "56ch",
        fontSize: "clamp(1.0625rem, 1rem + 0.3vw, 1.1875rem)",
        lineHeight: 1.6,
        opacity: paragraph.isVisible ? 1 : 0,
        transform: paragraph.isVisible ? "translateY(0)" : "translateY(16px)",
        transition: "opacity 600ms cubic-bezier(0.2,0,0,1) 160ms, transform 600ms cubic-bezier(0.2,0,0,1) 160ms"
      }}>
          MetPro Partners executes multi-year sales mandates through a rigorous, data-driven intake process. We execute a rigorous data‑driven intake process to understand your market position, supply chain integration, and industrial capacity—no filler, no fluff, only the critical metrics required to scale your manufacturing footprint.
        </p>

        <div ref={cta.ref} className="mt-12 flex flex-col items-center gap-4" style={{
        opacity: cta.isVisible ? 1 : 0,
        transform: cta.isVisible ? "translateY(0)" : "translateY(16px)",
        transition: "opacity 600ms cubic-bezier(0.2,0,0,1) 240ms, transform 600ms cubic-bezier(0.2,0,0,1) 240ms"
      }}>
          <Button asChild className="h-12 px-7 bg-chart-1 text-primary-foreground hover:bg-chart-1/90 font-medium tracking-wide shadow-md">
            <Link to="/ContactPage">Initiate a sales assessment</Link>
          </Button>

          <Link to="/ContactPage" className="font-default text-sm text-foreground/85 hover:text-chart-1 border-b border-border hover:border-chart-1 pb-1 transition-colors duration-200">
            Or request a formal capability brief
          </Link>
        </div>
      </div>
    </section>;
}